import { action } from "nanostores";

import { $visualizer } from "@/stores/visualizer";

export const updateRenderView = action(
  $visualizer,
  "update render view",
  (store, renderView) => {
    store.setKey("selectedRenderView", renderView);
  }
);
